import { render, staticRenderFns } from "./multiPiecesConfig.vue?vue&type=template&id=28522e56&scoped=true&"
import script from "./multiPiecesConfig.vue?vue&type=script&lang=js&"
export * from "./multiPiecesConfig.vue?vue&type=script&lang=js&"
import style0 from "./multiPiecesConfig.vue?vue&type=style&index=0&id=28522e56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28522e56",
  null
  
)

export default component.exports